import { RootState } from '../store';

export const selectCustomizedBlockPage = (state: RootState) =>
  state.customizedBlockPage;
